module.exports = __webpack_public_path__ + "img/video.7b19ccec.png";